// Maria, 20 October 2026: the sections still to confirm, sent with each card as one list separated by commas
export const incompleteSectionList = sections => (Array.isArray(sections) ? sections : String(sections ?? '').split(','))
    .map(section => section.trim())
    .filter(Boolean);
